export default "__VITE_ASSET__a1de8d64__"